import React from 'react';
import Icon from '../../../components/AppIcon';
import useInView from '../../../hooks/useInView';

const ServiceCategories = () => {
  const [gridRef, gridVisible] = useInView({ threshold: 0.15 });
  const services = [
    { icon: 'Zap', title: 'Dépannage urgence', price: '89€', desc: 'Intervention rapide 24/7', color: '#ef4444' },
    { icon: 'Wrench', title: 'Installation', price: 'Sur devis', desc: 'Sanitaires, chauffe-eau', color: '#0ea5e9' },
    { icon: 'Settings', title: 'Maintenance', price: '69€/an', desc: 'Prévention et entretien', color: '#22c55e' },
    { icon: 'Droplet', title: 'Débouchage', price: '79€', desc: 'Canalisations, WC', color: '#06b6d4' },
    { icon: 'Search', title: 'Recherche fuite', price: '149€', desc: 'Détection précise', color: '#f59e0b' },
    { icon: 'Gauge', title: 'Pression eau', price: '59€', desc: 'Contrôle et réglage', color: '#14b8a6' },

  ];

  return (
    <section className="marketing-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <p className="marketing-kicker mb-4">Nos expertises</p>
          <h2 className="marketing-title text-3xl lg:text-5xl font-heading font-bold mb-4">
            Nos <span className="marketing-accent">services</span> de plomberie
          </h2>
          <p className="marketing-muted text-lg max-w-2xl mx-auto">
            Des solutions adaptées à tous vos besoins, avec des tarifs transparents et des techniciens qualifiés.
          </p>
        </div>
        
        <div ref={gridRef} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {services?.map((service, index) => (
            <div
              key={index}
              className={`reveal-on-scroll ${gridVisible ? 'is-visible' : ''}`}
              style={{ '--reveal-delay': `${index * 80}ms` }}
            >
              <div className="marketing-card h-full text-center p-4 cursor-pointer">
                <div className="w-14 h-14 mx-auto mb-3 rounded-xl flex items-center justify-center" style={{ background: `${service.color}18` }}>
                  <Icon name={service?.icon} size={28} style={{ color: service.color }} />
                </div>
                <h3 className="text-sm font-semibold text-white mb-1">{service?.title}</h3>
                {/* <div className="text-lg font-bold mb-1" style={{ color: service.color }}>{service?.price}</div> */}
                <p className="marketing-muted text-xs">{service?.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCategories;